import { render, staticRenderFns } from "./Popper.vue?vue&type=template&id=da5602f2&scoped=true"
import script from "./Popper.vue?vue&type=script&lang=js"
export * from "./Popper.vue?vue&type=script&lang=js"
import style0 from "./Popper.vue?vue&type=style&index=0&id=da5602f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5602f2",
  null
  
)

export default component.exports